// @ts-nocheck
import { useCompatQuery, useCompatMutation } from './useApolloCompat';
import {
  COMPANY_QUERY,
  BRANCHES_QUERY,
  DEPARTMENTS_QUERY,
  UPDATE_COMPANY_MUTATION,
  CREATE_DEPARTMENT_MUTATION,
  CREATE_BRANCH_MUTATION,
} from '../graphql/operations';

export function useCompany() {
  return useCompatQuery(COMPANY_QUERY);
}

export function useUpdateCompany() {
  return useCompatMutation(UPDATE_COMPANY_MUTATION, {
    refetchQueries: [{ query: COMPANY_QUERY }],
  });
}

export function useBranches() {
  return useCompatQuery(BRANCHES_QUERY);
}

export function useDepartments() {
  return useCompatQuery(DEPARTMENTS_QUERY);
}

export function useCreateDepartment() {
  return useCompatMutation(CREATE_DEPARTMENT_MUTATION, {
    refetchQueries: [{ query: DEPARTMENTS_QUERY }],
  });
}

export function useCreateBranch() {
  return useCompatMutation(CREATE_BRANCH_MUTATION, {
    refetchQueries: [{ query: BRANCHES_QUERY }],
  });
}
